module.exports = __webpack_public_path__ + "static/media/travel.24dfe1c1.png";